import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {optionsAddedOrChanged} from "../../actions/OptionsActions";
import Text from "@amzn/meridian/text";
import Select from "@amzn/meridian/select";
import SelectOption from "@amzn/meridian/select/select-option";
import Column from "@amzn/meridian/column";
import {FormattedMessage} from "react-intl";
import {getLocale} from "../../handler/LocaleHandler";
import {Capability} from "../../enums";

class AisleOptions extends Component {
    render() {

        const {clusterAislesMap, selectedClusters, allAisles, selectedAisle} = this.props;
        const {textId, defaultMessage} = this.getTextDetails()

        function getAislesToDisplay() {
            if (selectedClusters && selectedClusters.length) {
                const displayAisles = [];
                selectedClusters.forEach(selectedCluster =>
                    displayAisles.push(...clusterAislesMap[selectedCluster])
                )
                return displayAisles.sort((a1, a2) => a1.localeCompare(a2, getLocale(), {numeric: true}));
            } else {
                return allAisles.sort((a1, a2) => a1.localeCompare(a2, getLocale(), {numeric: true}));
            }
        }

        const displayAisles = getAislesToDisplay();

        const getSelectedAisle = () => {
            if (displayAisles.includes(selectedAisle)) {
                return selectedAisle;
            } else {
                this.handleAisleChange("")
                return "";
            }
        };

        return (
            <Column>
                <Text type="h100" alignment="left">
                    <FormattedMessage id={textId} defaultMessage={defaultMessage}/>
                </Text>
                <Select
                    onChange={clickedAisle => this.handleAisleChange(selectedAisle, clickedAisle)}
                    value={getSelectedAisle()}
                    size="small"
                    placeholder={<FormattedMessage id={textId} defaultMessage={defaultMessage}/>}
                    width={150}>
                    {displayAisles && displayAisles.map(aisle => (
                        <SelectOption label={aisle} value={aisle} data-cy={"aisleFieldsetOption"}/>
                    ))}
                </Select>
            </Column>
        )
    }

    getTextDetails() {
        if(Capability.SSD === this.props.capability) {
            return {
                textId: "floorOptions.cartLocation",
                defaultMessage: "Cart Location"
            }
        }
        return {
            textId: "aisleOptions.aisle",
            defaultMessage: "Aisle"
        }
    }

    handleAisleChange(selectedAisle, clickedAisle) {
        const updatedAisle = selectedAisle === clickedAisle ? "" : clickedAisle;
        this.props.dispatch(optionsAddedOrChanged(
            {
                'aisle': updatedAisle
            }))
    }
}

const mapStateToProps = state => ({
    selectedAisle: state.optionsReducer.options.aisle,
    selectedClusters: state.optionsReducer.options.clusters,
    allAisles: state.optionsReducer.allAisles,
    clusterAislesMap: state.optionsReducer.clusterAislesMap,
    capability: state.optionsReducer.capability
});
export default withRouter(connect(mapStateToProps)(AisleOptions));


// WEBPACK FOOTER //
// ./src/components/options/AisleOptions.js